module.exports = {
  SEND_SMS: 'SEND_SMS',
  SEND_SMS_SUCCESS: 'SEND_SMS_SUCCESS',
  SEND_SMS_FAILURE: 'SEND_SMS_FAILURE',
  RECEIVE_SMS: 'RECEIVE_SMS'
};
